<script>
    export let testo, foto, datetime, biglietti;

    let divElement
    $: divElement && isFuture(datetime) ? divElement.style.setProperty('--bg-color', '#fafafa') : document.documentElement.style.setProperty('--bg-color', 'rgba(240, 0, 0, 0.25)')

    function isFuture(date) {
        var givenDateTime = date; // Format: YYYY-MM-DDTHH:mm:ss
        var givenDateTimeObj = new Date(givenDateTime);
        var currentDateTime = new Date();

        if (givenDateTimeObj > currentDateTime) {
            // console.log(true)
            // document.documentElement.style.setProperty('--bg-color', '#fafafa');
            return true
        } else {
            // console.log(false)
            // document.documentElement.style.setProperty('--bg-color', 'rgba(240, 0, 0, 0.3)');
            return false
        }
    }

    // isFuture('2024-11-27T16:30:00')
    
    
</script>

<div class="visita" bind:this={divElement}>
    <img src={foto} height="150" alt={testo} />
    
    <div class="descrizione">
        <p>{testo}</p>
        <p>{new Date(Date.parse(datetime)).toLocaleString('it-IT')}</p>
        <p>{biglietti} Biglietti</p>
    </div>
</div>

<style>
    :root {
        --bg-color: #fafafa;
    }
    .visita {
        display: flex;
        margin-bottom: 8px;
        padding: 4px;
        border-style: solid;
        border-width: 1px;
        border-color: lightgray;
        background: var(--bg-color);
    }

    .descrizione {
        margin-left: 8px;
        font-size: large;
    }
</style>